// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\App\WartsilaEnrichments\WartsilaEnrichmentsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { EnhancedEstimateQuery, EnhancedEstimateQueryData, EnhancedEstimateQueryOptions } from 'data/models/EnhancedEstimateQuery';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';

// WartsilaEnrichmentsResponseData is the class that WartsilaEnrichmentsResponse serializes to/from
export interface WartsilaEnrichmentsResponseData {
    Id : number;
	
    PortCall : PortCallData | null;
    RelevantQuery : EnhancedEstimateQueryData | null;
	
}

// WartsilaEnrichmentsResponseOptions is the class which may be passed to the WartsilaEnrichmentsResponse constructor to define optional initial data values
export interface WartsilaEnrichmentsResponseOptions {
    Id : number;
	
    PortCall? : PortCallOptions | null;
    RelevantQuery? : EnhancedEstimateQueryOptions | null;
	
}

export class WartsilaEnrichmentsResponse {
    public Id : DataSignal<number>;
	
    public PortCall : DataSignal<PortCall | null>;
    public RelevantQuery : DataSignal<EnhancedEstimateQuery | null>;
	

    constructor();
    constructor(data : WartsilaEnrichmentsResponseOptions);
    constructor(data: WartsilaEnrichmentsResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.PortCall = S.value<PortCall | null>(null);
        this.RelevantQuery = S.value<EnhancedEstimateQuery | null>(null);
	    
    }

    static key(obj : WartsilaEnrichmentsResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : WartsilaEnrichmentsResponseOptions) {
        return obj.Id;
    }

    static update(obj : WartsilaEnrichmentsResponse, data : WartsilaEnrichmentsResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/WartsilaEnrichmentsResponse.ts